import { FormField } from '../../../types/form-builder.types';
import { useLanguage } from '@shondalai/ui-commons';

interface SelectFieldProps {
  field: FormField;
  value: any;
  onChange: (value: any) => void;
  error?: string;
}

export function SelectField({ field, value, onChange }: SelectFieldProps) {
  const config = field.config;
  const options = config.options || [];
  const { t } = useLanguage();

  return (
    <select
      id={field.id}
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      required={config.required}
      className="easyforms-field-select"
    >
      <option value="">{config.placeholder || t('COM_EASYFORMS_SELECT_OPTION', 'Select an option')}</option>
      {options.map((option, index) => (
        <option key={option.id || `option-${index}`} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}
